<div class="layout py-12">
  <h2 class="font-bold text-4xl leading-tight text-bleuCaliceo-300 uppercase">
    {{ 'ourValues' | translate }}
  </h2>
</div>
<div class="layout py-12 bg-bleuCaliceo-300 flex flex-col gap-4">
  @for (value of values; track value) {
    <div class="text-white flex">
      <div class="text-7xl font-bold w-32">{{ value }}</div>
      <div class="flex flex-col w-full">
        <div class="text-xl font-bold">{{ 'ourValues.' + value + '.title' | translate }}</div>
        <div class="text-base font-medium">{{ 'ourValues.' + value + '.description' | translate }}</div>
      </div>
    </div>
  }
</div>
<div class="layout py-12">
  <div class="flex flex-col gap-6 justify-center items-start">
    <p [innerHtml]="'ourValues.signature' | translate"
       class="font-medium text-gray-500 text-md whitespace-pre-line">
    </p>
    <div class="w-full relative aspect-[3/2]">
      <img alt="" class="object-cover rounded-lg" fill="" loading="lazy"
           ngSrc="assets/images/rh/rh-caliceo-pro.webp">
    </div>
  </div>
</div>
